module.exports = __webpack_public_path__ + "img/ic_delete.14b1ff86.svg";